var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEveryUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.75C6.0335 12.75 5.25 13.5335 5.25 14.5C5.25 15.4665 6.0335 16.25 7 16.25C7.9665 16.25 8.75 15.4665 8.75 14.5C8.75 13.5335 7.9665 12.75 7 12.75ZM3.75 14.5C3.75 12.7051 5.20507 11.25 7 11.25C8.79493 11.25 10.25 12.7051 10.25 14.5C10.25 16.2949 8.79493 17.75 7 17.75C5.20507 17.75 3.75 16.2949 3.75 14.5Z",
    fill: "#676767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.75C16.0335 12.75 15.25 13.5335 15.25 14.5C15.25 15.4665 16.0335 16.25 17 16.25C17.9665 16.25 18.75 15.4665 18.75 14.5C18.75 13.5335 17.9665 12.75 17 12.75ZM13.75 14.5C13.75 12.7051 15.2051 11.25 17 11.25C18.7949 11.25 20.25 12.7051 20.25 14.5C20.25 16.2949 18.7949 17.75 17 17.75C15.2051 17.75 13.75 16.2949 13.75 14.5Z",
    fill: "#676767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C11.0335 2.75 10.25 3.5335 10.25 4.5C10.25 5.4665 11.0335 6.25 12 6.25C12.9665 6.25 13.75 5.4665 13.75 4.5C13.75 3.5335 12.9665 2.75 12 2.75ZM8.75 4.5C8.75 2.70507 10.2051 1.25 12 1.25C13.7949 1.25 15.25 2.70507 15.25 4.5C15.25 6.29493 13.7949 7.75 12 7.75C10.2051 7.75 8.75 6.29493 8.75 4.5Z",
    fill: "#676767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 22C1.25 18.8244 3.82436 16.25 7 16.25C10.1756 16.25 12.75 18.8244 12.75 22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22C11.25 19.6528 9.34719 17.75 7 17.75C4.65279 17.75 2.75 19.6528 2.75 22C2.75 22.4142 2.41421 22.75 2 22.75C1.58579 22.75 1.25 22.4142 1.25 22Z",
    fill: "#676767"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 22C11.25 18.8244 13.8244 16.25 17 16.25C20.1756 16.25 22.75 18.8244 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75C21.5858 22.75 21.25 22.4142 21.25 22C21.25 19.6528 19.3472 17.75 17 17.75C14.6528 17.75 12.75 19.6528 12.75 22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22Z",
    fill: "#676767"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 12C6.25 8.82439 8.82439 6.25 12 6.25C15.1756 6.25 17.75 8.82439 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75C16.5858 12.75 16.25 12.4142 16.25 12C16.25 9.65281 14.3472 7.75 12 7.75C9.65281 7.75 7.75 9.65281 7.75 12C7.75 12.4142 7.41421 12.75 7 12.75C6.58579 12.75 6.25 12.4142 6.25 12Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveryUser);
export default __webpack_public_path__ + "static/media/every-user.120f374f08e64a84602b3c24f66b243a.svg";
export { ForwardRef as ReactComponent };